import { MenuList as MuiMenuList } from '@mui/material';
import { clsx } from 'clsx';
import { PropsWithChildren } from 'react';
import { StyledPopperProps, StyledPopper } from './Popper/Popper';

export interface MenuProps extends StyledPopperProps {
  menuListClassName?: string;
}

export function Menu({
  open,
  children,
  menuListClassName,
  ...props
}: PropsWithChildren<MenuProps>) {
  return (
    <StyledPopper open={open} {...props}>
      <MuiMenuList className={clsx(menuListClassName || '')} autoFocusItem={open}>
        {children}
      </MuiMenuList>
    </StyledPopper>
  );
}
